// Module
var code = `<div class="row">
	<table class="table">
		<tr>
			<th>Step</th>
			<th>Step name</th>
			<th>Players</th>
			<th>Percent</th>
			<th>Churn Rate</th>
		</tr>
		<tr ng-repeat="step in steps_names">
			<td>{{data[step.num-1].number}}</td>
			<td>{{step.description}}</td>
			<td>{{data[step.num-1].players}}</td>
			<td>{{data[step.num-1].percent | number:2}}</td>
			<td>{{data[step.num-1].churn_rate | number:2}}</td>
		</tr>
	</table>
</div>





`;
// Exports
module.exports = code;